export const SPREADSHEET_ERROR_TIMEOUT = 10_000;
